module.exports = __webpack_public_path__ + "static/jiva5-7897789b30e499920e465345d14630da.png";